import { render, staticRenderFns } from "./GeneralWidget.vue?vue&type=template&id=2cc95a62&scoped=true&"
import script from "./GeneralWidget.vue?vue&type=script&lang=js&"
export * from "./GeneralWidget.vue?vue&type=script&lang=js&"
import style0 from "./GeneralWidget.vue?vue&type=style&index=0&id=2cc95a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../rebuild/yeh/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc95a62",
  null
  
)

export default component.exports